import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { DepartmentModel } from "./dept.model";

export class DepartmentDropResponse extends GlobalResponseObject {
    data?: DepartmentModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DepartmentModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}